import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { WeatherStation, CreateWeatherStationDto } from 'types';

export const createWeatherStation = (
  data: CreateWeatherStationDto
): Promise<WeatherStation> => {
  return axios.post('/api/weather/stations', data);
};

type UseCreateWeatherStationOptions = {
  config?: MutationConfig<typeof createWeatherStation>;
};

export const useCreateWeatherStation = ({
  config,
}: UseCreateWeatherStationOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousWeatherStations) {
        queryClient.setQueryData(
          ['weatherStations'],
          context.previousWeatherStations
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['weatherStations']);
    },
    ...config,
    mutationFn: createWeatherStation,
  });
};
